














































import { editFactory } from '@/main/pages';
import { Dodavatel } from '@/modules/ciselnik/skladove/dodavatel';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';


export default editFactory(NAME, store).extend({
	components: {
		DodavatelSelect: Dodavatel.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				dodavatel: `${this.storeUri}/${editMutations.VYROBEK_ND_DODAVATEL_SELECT_MAPPER}`,
			};
		},

		GenerateQuotationPrp(): boolean {
			return this.dmsSys.GenerateQuotationPrp!;
		},
	},
});
